import React, { FC, useState } from 'react';
import {
  getProductFormData,
  getTotalFormData,
} from './finishedGoodsLayoutData';
import FieldsRow from 'shared/components/FieldsRow';
import { Col, Row } from 'antd';
import styles from './finishedGoods.module.scss';
import { FormType } from 'enums/FieldTypeEnums';
import {
  FieldArrayWithId,
  UseFieldArrayRemove,
  useFormContext,
} from 'react-hook-form';
import { Category4 } from 'models/Scope3/category4.model';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import LocationModal, { generateAddressLabel } from '../LocationModal';
import { Address } from 'models/Address/address.model';

interface FinishedGoodsProps {
  fields: FieldArrayWithId<Category4, 'finishedGoods.products', 'id'>[];
  remove: UseFieldArrayRemove;
}

const FinishedGoods: FC<FinishedGoodsProps> = ({ fields, remove }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>();
  const { setValue, watch, trigger } = useFormContext();
  const [openLocationModal, setOpenLocationModal] = useState<boolean>(false);

  const handleSwitchChange =
    (index: number): SwitchChangeEventHandler =>
    checked =>
      setValue(
        `finishedGoods.products[${index}].companyPaymentPercentage`,
        checked ? 100 : null
      );

  const toggleLocationModal = () => setOpenLocationModal(prev => !prev);

  const handleAddAddress = (address: Address) => {
    setValue(`finishedGoods.products[${selectedIndex}].address`, address);
    const label = generateAddressLabel(address);
    setValue(`finishedGoods.products[${selectedIndex}].addressLabel`, label, {
      shouldTouch: true,
      shouldValidate: true,
    });
    toggleLocationModal();
  };

  const showLocationModal = (index: number) => {
    setSelectedIndex(index);
    toggleLocationModal();
  };

  const validate = async () => await trigger('finishedGoods');

  const totalFormData = getTotalFormData(validate);

  return (
    <Row>
      <Col span={24}>
        <FieldsRow {...totalFormData} formType={FormType.REACT_HOOK_FORMS} />
      </Col>
      {fields?.map((field, index) => (
        <Col span={24} className={styles.fieldsRow} key={field?.id}>
          <FieldsRow
            {...getProductFormData({
              index,
              remove,
              handleSwitchChange,
              disabled: !!watch(
                `finishedGoods.products[${index}].isCompletelyPaidByCompany`
              ),
              arrayLength: fields?.length,
              toggleLocationModal: showLocationModal,
              validate,
            })}
            formType={FormType.REACT_HOOK_FORMS}
            rowClassName={styles.wrapClassname}
          />
        </Col>
      ))}
      <LocationModal
        showModal={openLocationModal}
        onCancel={toggleLocationModal}
        handleSubmit={handleAddAddress}
        initialValue={watch(`finishedGoods.products[${selectedIndex}].address`)}
      />
    </Row>
  );
};

export default FinishedGoods;
